module.exports = __webpack_public_path__ + "img/Flag_of_Samoa.14b82a06.svg";